import { resolveImagePath } from '@/utils/imageResolver';

export function ImageGallery() {
  const galleryImages = [
    {
      src: '/images/gallery-maintenance-work.jpg',
      alt: 'Thoroughbred Aviation Maintenance, Parts and Service',
      title: 'Aircraft maintenance work'
    },
    {
      src: '/images/gallery-airplane-paint.jpg',
      alt: 'Thoroughbred Aviation Maintenance, Parts, Avionics, Painting',
      title: 'Aircraft painting services'
    },
    {
      src: '/images/gallery-hangar-interior.jpg',
      alt: 'Thoroughbred Aviation Maintenance, Parts and Service',
      title: 'Hangar interior and maintenance facility'
    }
  ];

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {galleryImages.map((image, index) => (
            <div key={index} className="overflow-hidden rounded-lg shadow-lg">
              <img
                src={resolveImagePath(image.src)}
                alt={image.alt}
                title={image.title}
                className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}